import { matchPath, useLocation, useNavigate } from 'react-router-dom';
import { ReactComponent as LogOutIcon } from 'assets/icons/logOut.svg';
import IconButton from 'components/IconButton/IconButton';
import AppRoutes from 'constants/AppRoutes';
import { USERS_ROLE } from 'constants/interfaces';
import { sidebarNav } from 'constants/navigationLists';
import { useAppDispatch } from 'store/hooks/useApp';
import { useLogoutMutation } from 'store/slices/auth/apis/auth';
import { logoutUser } from 'store/slices/auth/slice';
import { useUserMeQuery } from 'store/slices/user/apis/user';

import useTheme from '../../hooks/useTheme';
import SidebarItem from './components/SidebarItem/SidebarItem';

import type { ReactElement } from 'react';

import styles from './sass/Sidebar.module.scss';

function isLaunchpadSidebarRoute(pathname: string): boolean {
  return !!matchPath({ path: AppRoutes.launchpadHub, end: true }, pathname)
    || !!matchPath({ path: AppRoutes.launchpad, end: true }, pathname);
}

function Sidebar(): ReactElement {
  const { pathname } = useLocation();
  const dispatch = useAppDispatch();
  const [logout] = useLogoutMutation();
  const { data } = useUserMeQuery();
  const { resetToDefaultTheme } = useTheme();

  const { role } = data?.data || {};
  const navigate = useNavigate();
  const isSuperAdmin = role === USERS_ROLE.admin;
  const isLaunchpadRoute = isLaunchpadSidebarRoute(pathname);

  const onClickLogout = (() => {
    logout()
      .unwrap()
      .then(() => {
        dispatch(
          logoutUser(),
        );
        resetToDefaultTheme();
        navigate(AppRoutes.login);
      });
  });
  return (
    <aside className={isLaunchpadRoute ? styles.asideLaunchpad : styles.aside}>
      <div className={styles.links}>
        {role ? sidebarNav[role].map(({
          to, icon, key, alwaysVisible,
        }) => (
          <SidebarItem
            to={to}
            icon={icon}
            pillarKey={key}
            key={key}
            isSuperAdmin={isSuperAdmin}
            alwaysVisible={alwaysVisible}
          />
        )) : null}

      </div>
      <IconButton
        icon={<LogOutIcon width={30} height={30} />}
        onClick={onClickLogout}
        className={styles.logout}
      />
    </aside>
  );
}

export default Sidebar;
